/**
 * cyrb53 (c) 2018 bryc (github.com/bryc)
 *
 * A fast and simple hash function with decent collision resistance.
 * Largely inspired by MurmurHash2/3, but with a focus on speed/simplicity.
 *
 * @returns 53-bit integer
 *
 * @license Public-domain. Attribution appreciated.
 * @see https://github.com/bryc/code/blob/master/jshash/experimental/cyrb53.js
 * @see https://stackoverflow.com/a/52171480/6196258
 */
export function cyrb53(str: string, seed = 0) {
  let h1 = 0xdeadbeef ^ seed; // eslint-disable-line unicorn/number-literal-case
  let h2 = 0x41c6ce57 ^ seed; // eslint-disable-line unicorn/number-literal-case
  for (let i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i); // eslint-disable-line unicorn/prefer-code-point
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 =
    Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^
    Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 =
    Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^
    Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}
